/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownMedicalClearanceStatus } from '../models/db_DropdownMedicalClearanceStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MedicalClearanceStatuses {
    /**
     * Get a list of medical clearance statuses
     * @returns db_DropdownMedicalClearanceStatus OK
     * @throws ApiError
     */
    public static listMedicalClearanceStatuses(): CancelablePromise<Array<db_DropdownMedicalClearanceStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/medical-clearance-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
